import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, message, Row, Col } from 'antd';
import axios from '../../config/axiosInstance';

const { Option } = Select;

const DeviceEditForm = ({ editingDevice, onClose }) => {
  const [form] = Form.useForm(); 

  useEffect(() => {
    if (editingDevice) {
      form.setFieldsValue({
        ...editingDevice,
      });
    } else {
      form.resetFields();
    }
  }, [editingDevice, form]);

  const handleSave = async (values) => {
    try {
      // Performs device update
      await axios.put(`/devices/${editingDevice._id}`, values);

      message.success('Device updated successfully');
      onClose(); 
    } catch (error) {
      console.error('Error updating device:', error);
      message.error('Error updating device');
    }
  };

  const handleCancel = () => {
    onClose(); 
  };

  return (
    <Modal
      title="Edit Device"
      open={!!editingDevice} 
      onCancel={handleCancel}
      onOk={() => form.submit()} 
      okText="Save"
      cancelText="Cancel"
    >
      <Form
        form={form}
        onFinish={handleSave}
        layout="vertical"
      >
        {/* Fields in full column */}
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
                name="Name"
                label="Name"
                rules={[{ required: true, message: 'Please enter the device name' }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
                name="SerialNumber"
                label="Serial Number"
            >
              <Input readOnly style={{  cursor: 'default', color: 'inherit' }} />
            </Form.Item>
          </Col>
        </Row>
        {/* Fields in two-column rows */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
                name="Platform"
                label="Platform"
                rules={[{ required: true, message: 'Please select a platform' }]}
            >
              <Select>
                <Option value="iOS">iOS</Option>
                <Option value="Windows">Windows</Option>
                <Option value="Android">Android</Option>
                <Option value="MacOS">MacOS</Option>
                <Option value="iPadOS">iPadOS</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="VersionString" label="Version">
              <Input readOnly style={{  cursor: 'default', color: 'inherit' }} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="Manufacturer" label="Manufacturer">
              <Input readOnly style={{  cursor: 'default', color: 'inherit' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
                name="Idiom"
                label="Idiom"
                rules={[{ required: true, message: 'Please select an idiom' }]}
            >
              <Select placeholder="Select a device idiom">
                <Select.Option value="Phone">Phone</Select.Option>
                <Select.Option value="Tablet">Tablet</Select.Option>
                <Select.Option value="Desktop">Desktop</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="Model" label="Model">
              <Input readOnly style={{  cursor: 'default', color: 'inherit' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="Type" label="Type">
              <Input readOnly style={{  cursor: 'default', color: 'inherit' }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default DeviceEditForm;